import {Photo, User} from "../../types/Types";
import React from "react";
import {Link, useNavigate} from "react-router-dom";
import {getPhotoDate, getTime, truncateString} from "../../util/Util";
import UserTag from "../../users/tag/UserTag";
import TruncatedPhotoTags from "../../tag/TruncatedPhotoTags";
import CameraTag from "../../tag/CameraTag";
import LabelTag from "../../tag/LabelTag";
import VerificationTag from "../../tag/VerificationTag";
import LikeButton from "../../tag/likes/LikeButton";
import CommentTag from "../../tag/CommentTag";

interface Props {
    photo: Photo;
    photoUser: User | undefined;
    currentUser: User;
    displayLocation: boolean
    displayEditButton: boolean
    likesMap: Map<string, boolean>
    disableImageNavigation?: boolean
    onLikeCountChange?: (photoId: string, adjustment: number) => void
    hideLikeButton?: boolean
    hideTimestamp?: boolean
}

function PhotoRow(props: Props) {
  const navigate = useNavigate();

  const handleImageClick = () => {
    navigate(`/photo/${props.photo.id}`);
  };

  return (
      <>
          <div className={"photo"}>
              <div onClick={props.disableImageNavigation ? undefined : handleImageClick} style={{cursor: props.disableImageNavigation ? 'pointer' : 'pointer'}}>
                  <img style={{borderRadius: "5px"}} className={"full-size-photo"} src={props.photo.smallSizeUrl} alt={props.photo.locationName} />
              </div>
              <div className={"ml-2"} style={{textAlign: "left"}}>
                  {/* Row 1: User and Tags and Like Button*/}
                  <div className={"mt-2 mb-1"}>
                      <small>
                          <CameraTag />
                          <div className={"d-inline-block ml-1"}>
                            {props.photoUser && <UserTag user={props.photoUser} visit={undefined} session={undefined} padRight={false} hideLocationDot={false} linksToTab={"photos"} />}
                            {!props.photoUser && props.photo.userName && (
                                <Link to={`/profile/${props.photo.userId}/photos`} className={"p-0 mr-1"}>
                                    <div className={"user-tag"}>
                                        <div className={"d-inline-block"}>{truncateString(props.photo.userName)}</div>
                                    </div>
                                </Link>
                            )}
                          </div>
                          {props.photo.tags.length > 0 && (
                              <div className="d-inline-block ml-1">
                                  <LabelTag/>
                                  <div className={"d-inline-block ml-1"}>
                                      <TruncatedPhotoTags tags={props.photo.tags.slice(0, 2)} count={0} bold={false} charLimit={12} />
                                  </div>
                              </div>
                          )}
                      </small>
                      {!props.hideLikeButton && (
                          <LikeButton
                              entityId={props.photo.id}
                              likeType="PHOTO"
                              initialLikeCount={props.photo.likeCount}
                              isLiked={props.likesMap.get(props.photo.id) === true}
                              currentUser={props.currentUser}
                              locationId={props.photo.locationId}
                              locationName={props.photo.locationName}
                              onLikeCountChange={props.onLikeCountChange}
                              marginRight={"0.4em"}
                          />
                      )}
                  </div>
                  
                  {/* Row 2: Location */}
                  <div className={"mb-1"}>
                      <small>
                        <VerificationTag active={false}/>
                        <div className={"d-inline-block ml-1"}>
                          <Link to={`/location/${props.photo.locationId}/photos`} className={"p-0"}>
                            <div className={`location-tag`}>{props.photo.locationName}</div>
                          </Link>
                        </div>
                        {props.photo.description && (
                          <div className={"d-inline-block ml-2"}>
                              <CommentTag onClick={() => navigate(`/photo/${props.photo.id}`)} />
                          </div>
                        )}
                      </small>
                  </div>
                  
                  {/* Row 3: Timestamp */}
                  {!props.hideTimestamp && (
                      <div style={{marginTop: "-8px"}}>
                          <div className="mr-1" style={{ float: "right" }}>
                            <small className={"d-inline-block"}>
                              <div className={"d-inline-block"}>{getPhotoDate(props.photo.createdAt)} - {getTime(props.photo.createdAt)}</div>
                            </small>
                          </div>
                      </div>
                  )}
              </div>
            </div>
      </>
    )
}

export default PhotoRow;
